import buttonReducers from '@launchos/plugins/webcomponents/v2/Button/reducers';
import formFieldReducers from '@launchos/plugins/webcomponents/v1/formField/reducers';
import { combineReducers } from "redux";

export default combineReducers({
  buttonReducers,
  formFieldReducers
});
